export const TREE_CONSTANTS = {
  INDENT_WIDTH: 20,
  LINE_OFFSET: 10,
} as const;

export const ITEM_HEIGHT = 44;
export const HEADER_HEIGHT = 36;
export const VIRTUALIZER_OVERSCAN = 5;
